/**************************************************************************************************/
/** @import Helpers/Utils                                                                        **/
/**************************************************************************************************/
import { PrintHelper } from '@/Helpers/Utils/PrintHelper'

/**************************************************************************************************/
/** @export Class @name NotificationsHelper                                                      **/
/**************************************************************************************************/
export class NotificationsHelper
{
	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public static askNotificationPermissions() : Promise<NotificationPermission> | undefined
	{
		if (this.isNotificationSupported())
		{
			return Notification.requestPermission()
		}
	}

	public static hasGrantedPermission() : boolean
	{
		if (this.isNotificationSupported())
		{
			return Notification.permission === 'granted'
		}
		return false
	}

	public static isNotificationSupported() : boolean
	{
		const isSupported = 'Notification' in window
		if (!isSupported)
		{
			PrintHelper.error('[Notifier] La Implementación de la API de Notificaciones no esta soportada por el Navegador!')
		}
		return isSupported
	}

	public static showNotificationWithActions(self: any, title: string, actions?: Array<any>) : void
	{
		self.registration.showNotification(title, { actions })
	}
}